import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return [
      'portrait',
      'landscape',
    ];
  }

  initialize() {
    const styles = getComputedStyle(this.element);
    const aspectRatioBreakpoint = styles.getPropertyValue('--aspect-ratio-breakpoint');
    const mediaQuery = window.matchMedia(`(min-aspect-ratio: ${aspectRatioBreakpoint})`);    

    try {
      // Modern browsers
      mediaQuery.addEventListener('change', (e) => this.handleBreakpointChange(e));
    } 
    catch (e1) {
      try {
        // Old browsers (deprecated)
        mediaQuery.addListener('change', (e) => this.handleBreakpointChange(e));
      } catch (e2) {
        console.error(e2);
      }
    }
    
    // Initial check
    this.handleBreakpointChange(mediaQuery);
  }

  handleBreakpointChange(e) {
    const isLandscape = e.matches ?? e.currentTarget?.matches;
    if(isLandscape) {
      this.enableVideoSrc(this.landscapeTarget);
    }
    else {
      this.enableVideoSrc(this.portraitTarget);
    }
  }

  enableVideoSrc(target) {    
    if(!target.src) {
      target.src = target.getAttribute("data-src");
    }
  }
};